export default "<div class=\"help-block\" ng-transclude>\n</div>";